import { ArrowLeft } from 'lucide-react'
import history from 'history/browser'
import { useCallback, startTransition } from 'react'
import { RouteConfig } from '@/router'

export default function Topbar({ routeConfig }: { routeConfig: RouteConfig }) {
  const handleBack = useCallback(() => {
    startTransition(() => {
      history.back()
    })
  }, [])

  if (routeConfig.topbar?.enabled == false) {
    return null
  }

  const name = routeConfig.topbar?.name

  return (
    <header
      id="topbar"
      className="[grid-area:topbar] p-3 bg-stone-950 text-stone-200 font-semibold h-full grid grid-cols-2"
    >
      {name && <h1 className="text-lg">{name}</h1>}
      <button className="justify-self-end col-start-2" onClick={handleBack}>
        <ArrowLeft className="w-6 h-6" />
      </button>
    </header>
  )
}
